import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import * as theme from '../theme'

import { Button } from '../atoms/Button'

const Navigation = styled.nav`
   display: flex;
   justify-content: space-between;
   align-items: center;
   width: 100%;
`

const Pagination = styled.div`
   text-align: center;
`

export const Step = styled.div``

const Content = styled.div`
   padding-bottom: ${theme.spacing.m};
`

const WizardWrapper = styled.div`
   padding: ${theme.spacing.xs};
`

export const Wizard = ({
   children,
   submitButton,
   currentStep,
   setCurrentStep,
   disableNext
}) => {
   const total = children ? children.length : 0

   function next() {
      setCurrentStep(currentStep < total ? currentStep + 1 : currentStep)
   }

   function previous() {
      setCurrentStep(currentStep !== 1 ? currentStep - 1 : 1)
   }

   function getRightButton() {
      if (currentStep === total) {
         return submitButton ? submitButton() : <></>
      }
      if (!disableNext) {
         return <Button label={'Next'} onClick={() => next()}></Button>
      } else {
         return <Button isDisabled label={'Next'}></Button>
      }
   }

   return (
      <WizardWrapper>
         <Content>{children && children[currentStep - 1]}</Content>
         <Navigation>
            {currentStep === 1 ? (
               <span></span> // empty element to remove button without breaking the layout
            ) : (
               <Button
                  isDisabled={currentStep === 1}
                  label={'Previous'}
                  onClick={() => previous()}
               />
            )}
            <Pagination>{`${currentStep} of ${total}`}</Pagination>
            {getRightButton()}
         </Navigation>
      </WizardWrapper>
   )
}

Wizard.propTypes = {
   /**
    * Render prop button showing on last step of wizard.
    */
   submitButton: PropTypes.func.isRequired
}
